import { render, staticRenderFns } from "./ProcessingCardDragGhost.vue?vue&type=template&id=35303a15&scoped=true&"
import script from "./ProcessingCardDragGhost.vue?vue&type=script&lang=js&"
export * from "./ProcessingCardDragGhost.vue?vue&type=script&lang=js&"
import style0 from "./ProcessingCardDragGhost.vue?vue&type=style&index=0&id=35303a15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35303a15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VIcon,VRow})
